import React from 'react';
import 'twin.macro';
import { TitleRow } from '../text';
import { capitalize } from '../../lib/helpers';

const userProfile = {
  general: {
    ranking: '#21547',
    level: '72',
  },
  kudos: {
    totaal: '12547',
    per_dag: '514',
    per_reaguursel: '1.35',
  },
  comments: {
    totaal: '12547',
    per_dag: '514',
    topreaguursels: '1.35',
  },
};

const ProfileRow = ({ title, value }) => (
  <div tw='flex mb-1.5'>
    <strong tw='flex-1'>{capitalize(title).replace('_', ' ')}</strong>
    <span tw='flex-1'>{value}</span>
  </div>
);

const convertObj = (list) => Object.keys(list).map((key) => ({ property: key, value: list[key] }));

export const SideBarProfile = () => {
  const username = 'username';
  const { general, kudos, comments } = userProfile;

  return (
    <div>
      <TitleRow tw='mb-1'>{username}</TitleRow>
      <div tw='mb-8'>
        {convertObj(general).map((item, index) => (
          <ProfileRow key={index} title={item.property} value={item.value} />
        ))}
      </div>
      <TitleRow Type='h4' tw='mb-1'>
        Kudos
      </TitleRow>
      <div tw='mb-8'>
        {convertObj(kudos).map((item, index) => (
          <ProfileRow key={index} title={item.property} value={item.value} />
        ))}
      </div>
      <TitleRow Type='h4' tw='mb-1'>
        Reaguursels
      </TitleRow>
      <div tw='mb-8'>
        {convertObj(comments).map((item, index) => (
          <ProfileRow key={index} title={item.property} value={item.value} />
        ))}
      </div>
    </div>
  );
};
